
import { ReactNode } from "react";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BackgroundGradientAnimation } from "@/components/ui/background-gradient-animation";

interface AuthFormLayoutProps {
  children: ReactNode;
  title: string;
  description: string;
}

export function AuthFormLayout({ children, title, description }: AuthFormLayoutProps) {
  return (
    <BackgroundGradientAnimation>
      <div className="min-h-screen flex items-center justify-center p-4">
        <Card className="w-full max-w-md backdrop-blur-lg bg-white/10 border-white/20">
          <CardHeader className="space-y-1">
            <CardTitle className="text-2xl font-bold text-white">
              {title}
            </CardTitle>
            <CardDescription className="text-white/70">
              {description}
            </CardDescription>
          </CardHeader>
          <CardContent>
            {children}
          </CardContent>
        </Card>
      </div>
    </BackgroundGradientAnimation>
  );
}
